var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.7998H8V22.7998H12V4.7998Z",
    fill: "#E57E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 17.2002H13.2V22.8002H17.2V17.2002Z",
    fill: "#26B99A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3999 13.5996H18.3999V22.7996H22.3999V13.5996Z",
    fill: "#26B99A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 8H2.80005V22.8H6.80005V8Z",
    fill: "#26B99A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20005 24C0.978849 24 0.800049 23.8212 0.800049 23.6V0.4C0.800049 0.1788 0.978849 0 1.20005 0C1.42125 0 1.60005 0.1788 1.60005 0.4V23.6C1.60005 23.8212 1.42125 24 1.20005 24Z",
    fill: "#E9E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 23.2004H0.4C0.1788 23.2004 0 23.0216 0 22.8004C0 22.5792 0.1788 22.4004 0.4 22.4004H23.6C23.8212 22.4004 24 22.5792 24 22.8004C24 23.0216 23.8212 23.2004 23.6 23.2004Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.054ee435b43df82624f195a3a09b425f.svg";
export { ForwardRef as ReactComponent };